import { TableRow, TableCell, useMediaQuery, useTheme, Typography, TableBody, Stack, styled, Link, Chip} from '@mui/material';
import { ReceiptItem } from '../../../types/reports/receiptItem';


interface Props {
   tableRows?:ReceiptItem[];
   displayFiler?: boolean;
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

const ContributionsTable = (props: Props): JSX.Element => {
    
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

        return (
                <TableBody>
                     {props.tableRows?.map((receipt) => (
                         <StyledTableRow key={receipt.id}>
                             <TableCell>
                                 <Typography variant={'body2'}>
                                     {receipt.date}
                                 </Typography>
                                 {
                                        receipt.isPreviousYearContribution &&
                                        <Chip label={new Date(receipt.date).getFullYear()-1}  color="primary" variant='outlined' size="small" />
                                 }
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'body2'} fontWeight={550}>
                                     {receipt.fullNameReverse} 
                                 </Typography>
                                 <Typography variant={'body2'} component={'i'}>
                                     {receipt.streetAddress}
                                 </Typography>
                             </TableCell>
                             {
                                isSM &&
                                <TableCell align='right'>
                                    <Typography variant={'body2'}>
                                        {receipt.amount}
                                        {
                                            receipt.recordTypeId >= 401 && receipt.recordTypeId<=499 && //inkind contribution
                                            <span>*</span>
                                        }
                                    </Typography>
                                </TableCell>
                             }
                             <TableCell>
                                <Typography variant={'body2'}>
                                    {receipt.city}
                                </Typography>
                             </TableCell>
                             <TableCell>
                                <Typography variant={'body2'}>
                                    {receipt.state}
                                </Typography>
                             </TableCell>
                             <TableCell>
                                <Typography variant={'body2'}>
                                    {receipt.zipCode}
                                </Typography>
                             </TableCell>
                             <TableCell>
                                 {
                                    receipt.recordTypeId === 403 ? //union contribution
                                        <Stack direction={'column'}>
                                            <Typography variant="body2">{receipt.principalOfficer} (principalOfficer)</Typography>
                                        </Stack>:
                                        <Stack>
                                            <Typography variant="body2">{receipt.occupation}</Typography>
                                            <Typography variant="body2"><i>{receipt.employer}</i></Typography>
                                        </Stack>
                                 }
                             </TableCell>
                             {
                                !isSM &&
                                <TableCell align='right'>
                                    <Typography variant={'body2'}>
                                        {receipt.amount}
                                        {
                                            receipt.recordTypeId >= 401 && receipt.recordTypeId<=499 && //inkind contribution
                                            <span>*</span>
                                        }
                                    </Typography>
                                </TableCell>
                             }
                            {
                                props.displayFiler?
                                <TableCell>
                                    <Stack>
                                        <Typography variant="body2">
                                            <Typography component={Link} href={`/filers?q=${receipt.filerCpfId}`} target="_blank" underline="hover" variant="body2">{receipt.filerCpfId}</Typography> {receipt.filerFullNameReverse}
                                        </Typography>
                                        <Typography component={Link} href={`/reports/displayreport?id=${receipt.reportId}`} target="_blank" underline="hover" variant="body2"><i>{receipt.sourceDescription?receipt.sourceDescription:'Source'}</i></Typography>
                                    </Stack> 
                                </TableCell>
                                :
                                <TableCell>
                                    <Typography component={Link} href={`/reports/displayreport?id=${receipt.reportId}`} target="_blank" underline="hover" variant="body2">{receipt.sourceDescription?receipt.sourceDescription:'Source'}</Typography>
                                </TableCell>   
                             }                                  
                         </StyledTableRow>
                    ))}
                 </TableBody>
        );
}

export default ContributionsTable;